import { createSelector } from "reselect";

import type {
  PublicPriceGroup,
  PublicPriceGroupV4
} from "@busbud/core-types/dist/lib/poll-service/api";

import { getLegCards } from "./get-leg-cards";
import {
  getSegmentsFromTripLeg,
  getSearchedLeg
} from "../../../../helpers/udm";
import { getSourcesById } from "../get-sources";
import {
  getTrips,
  getTripsSegments,
  getSearch,
  getExcludedSourcesFilter
} from "../state-accessors";

export const getFilteredLegCardIdsByExcludedSources = createSelector(
  [
    getLegCards,
    getTrips,
    getTripsSegments,
    getExcludedSourcesFilter,
    getSearch,
    getSourcesById
  ],
  (
    leg_cards,
    trips,
    segments,
    excluded_sources,
    search,
    sources_by_id
  ): string[] => {
    const leg_card_ids = Object.keys(leg_cards);

    if (!excluded_sources.length) {
      return leg_card_ids;
    }

    const excluded_sources_slug = excluded_sources.reduce(
      (excluded_sources_slug: string[], excluded_source_id: number) => {
        const source_slug = sources_by_id[excluded_source_id];
        if (source_slug) {
          excluded_sources_slug.push(source_slug);
        }

        return excluded_sources_slug;
      },
      []
    );

    return leg_card_ids.filter(id => {
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const trip_id = leg_cards[id][0];
      // @ts-expect-error TS2538 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const trip = trips[trip_id];
      const leg = getSearchedLeg(search, trip);
      const leg_segments = getSegmentsFromTripLeg(leg, segments);

      const excluded_segments = getSegmentIdsFromExcludedSources(
        excluded_sources_slug,
        trip.prices
      );

      return leg_segments.every(
        segment => !excluded_segments.includes(segment.id)
      );
    });
  }
);

function getSegmentIdsFromExcludedSources(
  excluded_sources_slug: string[],
  prices: (PublicPriceGroup | PublicPriceGroupV4)[]
): string[] {
  return prices.reduce(
    (
      excluded_segments: string[],
      price: PublicPriceGroup | PublicPriceGroupV4
    ) => {
      if (excluded_sources_slug.includes(price.source_name)) {
        return excluded_segments.concat(price.segment_ids);
      }

      return excluded_segments;
    },
    []
  );
}
